import store from 'store'

export const userIdKey = 'perspective__user__id'

export const handleAnonId = () => {
  const storageUserId = store.get(userIdKey)

  if (!storageUserId) {
    const analyticsUserId = window.analytics.user().anonymousId()

    store.set(userIdKey, analyticsUserId)
  } else {
    window.analytics.user().anonymousId(storageUserId)
  }
}

export const getUserId = (cb) => {
  if (window.analytics) {

    window.analytics.ready(function() {
      const userId = window.analytics.user().id() || store.get(userIdKey)

      cb(userId)
    })
  } else {
    cb(store.get(userIdKey))
  }
}

export const setCampaignCookieAccepted = (campaignId) => {
  store.set(`Accept_Cookies_${campaignId}`, 'true')
}

export const getCampaignCookieAccepted = (campaignId) => {
  return store.get(`Accept_Cookies_${campaignId}`)
}

export const setCampaignCookieShow = (campaignId) => {
  store.set(`Show_Cookie_Info_${campaignId}`, 'true')
}
export const getCampaignCookieShow = (campaignId) => {
  return store.get(`Show_Cookie_Info_${campaignId}`)
}
